import styled from "styled-components";
import { buttonTypography } from "../../../../components/typography/MuiTypography.style";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const ProgramSearchFormWrapper = styled.div`
  background-color: ${COLORS.cirrus_white};
  padding: 24px 0px 24px 16px;

  ${responsive.MOBILE`
    padding: 16px 8px 16px 8px;
  `}

  .MuiGrid2-root {
    padding-right: 16px;

    ${responsive.MOBILE`
      padding-right: 0px;
    `}
  }
  .program-search-radio-group {
    .MuiFormGroup-root {
      ${responsive.MOBILE`
        flex-direction: column;
      `}
    }
  }

  .MuiGrid2-container {
    padding: 0px;
    margin-top: 0;
  }
  .MuiPickersTextField-root,
  .MuiPickersInputBase-root {
    width: 100%;
  }

  .mui-label {
    color: ${COLORS.cirrus_black10};
    line-height: 20px;
    margin-bottom: 8px;
  }

  .expand-btn-container {
    width: 100%;
    margin-top: 32px;
    padding: 8px 16px;
    cursor: pointer;
    text-align: center;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    /* dotted line */
    &::before,
    &::after {
      content: "";
      position: absolute;
      top: 50%;
      border-top: 1px dotted ${COLORS.primary_light_blue5};
      width: clamp(20%, 35%, 40%);
    }

    &::before {
      left: 0;
      transform: translateY(-50%);
    }

    &::after {
      right: 0;
      transform: translateY(-50%);
    }

    .MuiIconButton-root {
      height: 28px;
      width: 28px;
      padding: 0;
      background-color: ${COLORS.cirrus_white};
      z-index: 1;
    }

    .expand-text {
      ${buttonTypography}
      line-height: 19.8px;
      text-align: center;
      color: ${COLORS.primary_light_blue};
      margin-right: 8px;
      cursor: pointer;
      height: 28px;
      display: inline-flex;
      align-items: center;
      background-color: ${COLORS.cirrus_white};
      padding: 0 8px;
      z-index: 1;
    }
  }

  .button-container {
    justify-content: end;
    margin-top: 32px;
    ${responsive.MOBILE`
      flex-direction: column-reverse;
      margin-top: 16px;
    `}
    button {
      ${responsive.MOBILE`
        width: 100%;
        margin: 0px;
      `}
    }
  }

  .toggle-parent-container {
    position: relative;
  }

  .toggle-container {
    position: absolute;
    top: -5px;
    right: 0px;
  }

  .toggle-phone-container {
    top: 0px;
  }
`;
